import React, { useEffect, useState } from "react";
import { useHookstate } from '@hookstate/core';
import { ItemServiceFactory } from "../../../../services/ItemServiceFactory";
import globalAuthStateStore from "../../../../stores/globalAuthStateStore";
import { VirtualLibrarianService } from "../../../../services/VirtualLibrarianService";
import { DialogControl } from "../../../../components/controls/DialogControl";
import BitmovinPlayer from '../../../contentLibrary/app-components/Content/Player/BitmovinPlayer';

const ContentModal = ({
    contentId,
    open,
    title,
    setOpen,
    okText,
    handleOk,
    timestamp
}) => {

    const authStore = useHookstate(globalAuthStateStore);
    const itemService = React.useMemo(() => ItemServiceFactory.GetItemService("content",authStore), [authStore]);

    const [item, setItem] = useState(null);
    useEffect(() => {
        async function fetchData() {
            const result = await itemService.single(contentId);
            if (result) {             
                setItem(result[0].Items[0]);
            }
        }
        if (open && contentId) {
            fetchData();
        }
    }, [contentId, open]);
    
    const checkIsVideo = (fileExtension) => {
        return (
            fileExtension === 'mp4' ||
            fileExtension === 'avi' ||
            fileExtension === 'mpg' ||
            fileExtension === 'mpga' ||
            fileExtension === 'streaming.media.azure.net'
        );
    }

    return (
        <DialogControl
            className="certq-details-ans-content-dialog"
            openDialog={open}
            title={title ?? item?.DisplayFileName}
            onCancel={() => setOpen(false)}
            okText={okText}
            onOk={(e) => {
                setOpen(false);
                handleOk(e);
            }}
        >
            {/* have a dialog with the openAnswerContent image or video */}
            {item?.File && (
                <div>
                    <div className={`__content ${checkIsVideo(item.File.FileExtention) ? "file-upload-image" : ""}`}>
                        {checkIsVideo(item.File.FileExtention) ? 
                            item.File && item.File.FileUrl !== null && item.File.FileUrl !== undefined ? 
                                <div className='video-player'>
                                    <div id='player-wrapper'>
                                        <BitmovinPlayer content={item.File} currentTimeStamp={timestamp ?? 0}/>
                                    </div>
                                </div>
                                : 
                                <></>
                          : (
                            <img
                                src={item.File.FileUrl}
                                alt="Answer Content"
                            />
                        )}
                    </div>
                    <div className="certq-filename">
                        <span>{item.File.DisplayFileName}</span>
                        <span>{"." + item.File.FileExtention}</span>
                    </div>
                </div>
            )}
        </DialogControl>
    );
}

export default ContentModal;